<template>
  <div id="app" onselectstart="return false">
    <router-view />
  </div>
</template>

<script>
export default {
  // mounted() {
  //   if (this._isMobile()) {
  //     window.location.href = "http://114.116.99.220:8866/shujinmobile/";
  //   }
  // },
  // methods: {
  //   _isMobile() {
  //     let flag = navigator.userAgent.match(
  //       /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  //     );
  //     return flag;
  //   }
  // }
};
</script>
